// server/browser/src/lib/ui/toast.svelte.ts
//
// Tiny global toast store (rune-based). Import `toasts` anywhere and call
// toasts.ok/warn/error/info; render <Toaster /> once in the shell.

export type ToastTone = "ok" | "warn" | "down" | "info";

export interface ToastItem {
  id: number;
  tone: ToastTone;
  message: string;
}

class ToastStore {
  items = $state<ToastItem[]>([]);
  private seq = 0;

  push(message: string, tone: ToastTone = "info", ms = 4200): number {
    const id = ++this.seq;
    this.items = [...this.items, { id, tone, message }];
    if (ms > 0 && typeof window !== "undefined") {
      window.setTimeout(() => this.dismiss(id), ms);
    }
    return id;
  }

  ok(m: string) {
    return this.push(m, "ok");
  }
  warn(m: string) {
    return this.push(m, "warn");
  }
  error(m: string) {
    return this.push(m, "down", 6000);
  }
  info(m: string) {
    return this.push(m, "info");
  }

  dismiss(id: number): void {
    this.items = this.items.filter((t) => t.id !== id);
  }
}

export const toasts = new ToastStore();
